export const meetingCardProperties = {
  defaultProperties: ['hs_meeting_title', 'hs_meeting_location', 'hs_meeting_location_type', 'hubspot_owner_id', 'hs_all_assigned_business_unit_ids', 'hs_meeting_external_url'],
  associationCardProperties: {
    primaryProperties: [],
    secondaryProperties: ['hs_meeting_title', 'hs_meeting_start_time', 'hs_meeting_end_time'],
    blocklistedSecondaryProperties: []
  }
};